import styled from "styled-components";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../theme/theme";
import CustomButton from "../CustomButton/CustomButton";
import educationIcon from "../../assets/educationIcon.jpg";
import retirementIcon from "../../assets/retirementIcon.jpg";
import majorPurchaseIcon from "../../assets/majorPurchaseIcon.jpg";
import buildWealthIcon from "../../assets/buildWealthIcon.jpg";
import {
  getUserGoal,
  getStepsByGoal,
  deleteGoal,
  setGoal,
} from "../../redux/actions";
import { SET_LOADING } from "../../redux/action-types";

const GoalCardWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  background-color: ${theme.colors.white};
  padding: 20px 30px;
  text-align: left;
  background-color: white;
  border-radius: 8px;
  border-left: ${(props) =>
    props.status === "Launched" ? "8px solid #6ADD98" : "8px solid #FFD233"};

  .left {
    flex: 1;
    position: relative;
  }

  .right {
    flex: 1;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .goalName {
    position: absolute;
    top: 14px;
    left: 4rem;
    color: ${theme.colors.primaryStrong2X};
    font-size: 16px;
  }

  .launchedMessage {
    font-size: 16px;
    font-weight: 700;
    color: #6add98;
  }

  .deleteButton {
    color: #e26841;
    margin-right: 20px;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    .goalImage {
      display: none;
    }
    .goalName {
      left: 0;
    }
    .right button {
      padding: 1em;
    }
  }
`;

const GoalCardInDashboard = ({ status, goalName, id }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { deleteUserGoalDetails } = useSelector((state) => state.user);

  const handleLinkClick = () => {
    //dispatch(setGoalToLaunch(id));
    dispatch(
      setGoal({
        id: id,
      })
    ).then(() => {
      history.push("/dashboard");
    });
  };

  const handleDeleteGoal = () => {
    dispatch({ type: SET_LOADING, payload: true });
    dispatch(deleteGoal(id));
  };

  useEffect(() => {
    if (deleteUserGoalDetails) {
      dispatch(getUserGoal());
    }
  }, [deleteUserGoalDetails, dispatch]);

  const handleContinueClick = () => {
    let type, path;
    if (goalName === "Education") {
      type = "Education";
      path = "/education";
    } else if (goalName === "Retirement") {
      type = "Retirement";
      path = "/retirement";
    } else if (goalName === "MajorPurchase") {
      type = "Major Purchase";
      path = "/major_purchase";
    } else if (goalName === "BuildWealth") {
      type = "Build Wealth";
      path = "/build_wealth";
    }

    dispatch(
      getStepsByGoal({
        type,
        link: id,
      })
    ).then(() => {
      history.push(path);
    });
  };
  return (
    <GoalCardWrapper status={status}>
      <div className="left">
        <img
          className="goalImage"
          alt="goal type logo"
          src={
            goalName === "Education"
              ? educationIcon
              : goalName === "Retirement"
              ? retirementIcon
              : goalName === "MajorPurchase"
              ? majorPurchaseIcon
              : goalName === "BuildWealth"
              ? buildWealthIcon
              : ""
          }
        />
        <span className="goalName">{goalName}</span>
      </div>
      <div className="right">
        {status === "Launched" ? (
          <div className="launchedMessage">Launch Request Submitted</div>
        ) : status === "NotLinked" ? (
          <>
            <span className="deleteButton" onClick={handleDeleteGoal}>
              Delete
            </span>
            <CustomButton
              text={"Continue"}
              buttonType="primary"
              onClick={handleLinkClick}
            ></CustomButton>
          </>
        ) : (
          <>
            <span className="deleteButton" onClick={handleDeleteGoal}>
              Delete
            </span>
            <CustomButton
              text={"Continue"}
              buttonType="primary"
              onClick={handleContinueClick}
            ></CustomButton>
          </>
        )}
      </div>
    </GoalCardWrapper>
  );
};

export default GoalCardInDashboard;
